(function () {

  "use strict";


  /* ==================================================
     INITIALIZE SECTION
  ================================================== */

  function initBehindScenes(root) {

    if (!root) {
      return;
    }


    const cards =
      root.querySelectorAll(
        "[data-video-card]"
      );


    cards.forEach(function (card) {

      const video =
        card.querySelector("video");


      const muteButton =
        card.querySelector(
          "[data-mute-button]"
        );


      const duration =
        card.querySelector(
          "[data-duration]"
        );


      if (!video) {
        return;
      }


      /* ================================================
         FORCE AUTOPLAY
      ================================================ */

      video.autoplay = true;

      video.loop = true;

      video.muted = true;

      video.playsInline = true;


      /* ================================================
         VIDEO DURATION
      ================================================ */

      function updateDuration() {

        if (
          !duration ||
          !Number.isFinite(
            video.duration
          )
        ) {

          return;

        }


        const totalSeconds =
          Math.floor(
            video.duration
          );


        const minutes =
          Math.floor(
            totalSeconds / 60
          )
            .toString()
            .padStart(2, "0");


        const seconds =
          (
            totalSeconds % 60
          )
            .toString()
            .padStart(2, "0");


        duration.textContent =
          minutes + ":" + seconds;

      }


      if (
        video.readyState >= 1
      ) {

        updateDuration();

      }


      video.addEventListener(
        "loadedmetadata",
        updateDuration
      );


      /* ================================================
         MUTE BUTTON
      ================================================ */

      function updateMuteButton() {

        if (!muteButton) {
          return;
        }


        if (video.muted) {

          muteButton.classList.add(
            "is-muted"
          );

          muteButton.setAttribute(
            "aria-label",
            "Unmute video"
          );

        } else {

          muteButton.classList.remove(
            "is-muted"
          );

          muteButton.setAttribute(
            "aria-label",
            "Mute video"
          );

        }

      }


      if (muteButton) {

        muteButton.addEventListener(
          "click",
          function (event) {

            event.preventDefault();

            event.stopPropagation();


            video.muted =
              !video.muted;


            updateMuteButton();

          }
        );

      }


      updateMuteButton();


      /* ================================================
         AUTOPLAY FUNCTION
      ================================================ */

      function startVideo() {

        /*
          Browser autoplay rules require
          videos to be muted.
        */

        video.muted = true;

        video.autoplay = true;

        video.loop = true;


        /*
          Pause every other video
        */

        root
          .querySelectorAll("video")
          .forEach(function (
            otherVideo
          ) {

            if (
              otherVideo !== video
            ) {

              otherVideo.pause();

            }

          });


        /*
          Start this video
        */

        const playPromise =
          video.play();


        if (
          playPromise !== undefined
        ) {

          playPromise.catch(
            function () {

              /*
                Some browsers may
                temporarily block autoplay.
              */

            }
          );

        }

      }


      /* ================================================
         STOP VIDEO
      ================================================ */

      function stopVideo() {

        video.pause();

      }


      /* ================================================
         INTERSECTION OBSERVER
      ================================================ */

      const observer =
        new IntersectionObserver(

          function (entries) {

            entries.forEach(
              function (entry) {

                if (
                  entry.isIntersecting
                ) {

                  startVideo();

                } else {

                  stopVideo();

                }

              }
            );

          },

          {
            threshold: 0.35
          }

        );


      observer.observe(card);


      /* ================================================
         TRY AUTOPLAY IMMEDIATELY
      ================================================ */

      startVideo();

    });

  }


  /* ==================================================
     INITIAL LOAD
  ================================================== */

  function initAll() {

    document
      .querySelectorAll(
        ".behind-scenes"
      )
      .forEach(function (section) {

        initBehindScenes(
          section
        );

      });

  }


  if (
    document.readyState ===
    "loading"
  ) {

    document.addEventListener(
      "DOMContentLoaded",
      initAll
    );

  } else {

    initAll();

  }


  /* ==================================================
     SHOPIFY THEME EDITOR
  ================================================== */

  document.addEventListener(
    "shopify:section:load",
    function (event) {

      const section =
        event.target.querySelector(
          ".behind-scenes"
        );


      if (section) {

        initBehindScenes(
          section
        );

      }

    }
  );


})();